import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SettingTabsChild',
  props: {
    tabName: null
  },
  setup(__props: any) {

const props = __props as {
    tabName: string
}



return { __sfc: true,props }
}

})